<template>
  <q-chip
    v-ripple="clickable"
    :style="chipStyle"
    :class="{'cursor-pointer': clickable}"
    :dense="dense"
    :size="dense ? '12px' : undefined"
    :color="color"
    square
    class="shadow-1 relative-position q-ma-none status-selector"
  >
    <div class="flex justify-between items-center full-width">
      <b>{{ label }}</b>
      <q-icon
        v-if="clickable"
        name="arrow_drop_down"
        class="q-ml-sm flex-shrink-0"
      />
    </div>
    <slot />
  </q-chip>
</template>

<script>
/**
 * Display status of an object in default style
 */
export default {
  props: {
    // Can the element be clickable
    clickable: {
      type: Boolean,
      default: false
    },
    // Label of status
    label: {
      type: String,
      required: true
    },
    // Color of the status
    color: {
      type: String,
      default: undefined
    },
    // Color of status (hex)
    hexColor: {
      type: String,
      default: undefined
    },
    // Condense size of element
    dense: {
      type: Boolean,
      default: false
    },
    // Minimum width of the chip
    minWidth: {
      type: String,
      default: undefined
    }
  },
  computed: {
    textColor () {
      return this.hexColor && this.checkBrightnessOfHex(this.hexColor) > 170 ? '#000' : '#FFF'
    },
    chipStyle () {
      return {
        'color': this.textColor,
        'background-color': this.hexColor,
        'min-width': this.minWidth
      }
    }
  }
}
</script>
